import '@mrigl/ui/styles.css';
import '../src/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConsoleApp } from '../src/console/ConsoleApp.js';

const container = document.getElementById('root');
if (container === null) throw new Error('#root missing');

createRoot(container).render(
  <StrictMode>
    <ConsoleApp />
  </StrictMode>,
);
